import React from 'react';
import Stats from '../components/Stats';

const UserStats = ({ user, books, userData, theme }) => {
  return (
    <div className="container">
      {user && <Stats books={books} userData={userData} theme={theme} />}
    </div>
  );
};

export default UserStats;
